import { useCallback } from 'react'
import { useIsAvpOnly } from '@/hooks/useIsAvpOnly'
import { fmtArticulo } from '@/utils/fmtArticulo'

/**
 * Devuelve un formateador de código de artículo atado al rol AVP actual.
 * Úsalo en CUALQUIER sitio que muestre un código de artículo/material.
 * Sirve para texto JSX, atributos (title) y concatenaciones de string.
 */
export function useFmtArticulo() {
  const isAvpOnly = useIsAvpOnly()
  return useCallback(
    (code: string | null | undefined) => fmtArticulo(code, isAvpOnly),
    [isAvpOnly],
  )
}
